import { LEARNER_ROUTES } from '../../constants';
import { Logo } from './Sidebar.styles';

export interface SidebarLogoProps {
  logoUrl: string;
  enterpriseName: string;
}

export function SidebarLogo({ logoUrl, enterpriseName }: SidebarLogoProps) {
  const TRANSLATED_HOME = window.I18n.t('js.learner.home.sidebar.home');

  return (
    <a href={LEARNER_ROUTES.home} title={TRANSLATED_HOME}>
      <Logo loading="lazy" decoding="async" src={logoUrl} alt={enterpriseName} />
    </a>
  );
}
